import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import WithWeather from 'modules/WithWeather';
/* import makeRequest from '../../../../utils/makeRequest'; */
import Link from 'components/Link';
import s from './Listingheader.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class Listingheader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      headingType = 'h2',
      isWhiteTheme,
      size,
      linkData,
      overrideClass,
      doNotChangeURL,
      subheading,
      target,
      data,
      ga4Type,
      ga4Category,
      isArrowNotNeeded,
    } = this.props;
    const listingClassName = classNames({
      [s.header]: true,
      [s.themewhite]: isWhiteTheme,
      [s[size]]: size,
      [s.loading]: this.props.loading,
      [`${overrideClass}`]: overrideClass,
    });
    //const DropdownComp = this.props.dropdownComp;
    const sponsoredTxt = data && data.sponsoredTxt ? data.sponsoredTxt : '';
    const sponsoredLink = data && data.sponsoredLink ? data.sponsoredLink : '';
    const sponsoredLogomsid =
      data && data.sponsoredLogomsid ? data.sponsoredLogomsid : '';
    const sponsoredClass =
      data && data.sponsoredClass ? data.sponsoredClass : '';

    let sponsoredData = '';
    if (sponsoredLink && sponsoredLogomsid) {
      sponsoredData = (
        <div className={`${data.isMlcPage ? 'isMlcPage' : s[sponsoredClass]}`}>
          <Link
            to={sponsoredLink}
            doNotChangeURL
            target="_blank"
            ga4Data={
              ga4Type && [
                {
                  event: 'user_click',
                  type: `${ga4Type}`,
                  category: `${ga4Category}`,
                },
              ]
            }
          >
            {data.isMlcPage ? sponsoredTxt : ''}
            <img
              src={`https://static.toiimg.com/photo/msid-${sponsoredLogomsid}.cms`}
              alt="Sponsored Txt"
            />
          </Link>
        </div>
      );
    } else if (sponsoredTxt && sponsoredLogomsid) {
      sponsoredData = (
        <div className={s[sponsoredClass]}>
          {sponsoredTxt}
          <img
            src={`https://static.toiimg.com/photo/msid-${sponsoredLogomsid}.cms`}
            alt={sponsoredTxt}
          />
        </div>
      );
    }

    const headerMapping = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

    const HeaderWrapper =
      headingType && headerMapping?.includes(headingType) ? headingType : 'h2';

    return (
      <InViewObserver
        inViewCallback={() => {
          if (
            typeof ga4Type !== 'undefined' &&
            ga4Type !== '' &&
            ga4Type !== 'toi_plus_stories_widget'
          ) {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: ga4Type,
              category: ga4Category || '',
            });
          }
        }}
      >
        <React.Fragment>
          <div className={`${listingClassName}`}>
            {this.props.headingLink ? (
              <>
                <HeaderWrapper className={`${s.heading}`}>
                  <Link
                    className={`${isArrowNotNeeded ? '' : s.linkarrow} ${
                      subheading ? s.arrowalign : ''
                    }`}
                    to={this.props.headingLink}
                    data={linkData}
                    data-newga={this.props.newga}
                    data-setgacategory={this.props.newgaSetCategory}
                    doNotChangeURL={doNotChangeURL}
                    // ga4Data={this.props.ga4DataHeading}
                    target={target === '_blank' ? target : ''}
                    ga4Data={
                      ga4Type && [
                        {
                          event: 'user_click',
                          type: `${ga4Type}`,
                          label: `${this.props.headingname
                            .toString()
                            .toLowerCase()}`,
                          category: `${'section_heading_click' || ga4Category}`,
                        },
                      ]
                    }
                  >
                    <span className={s.head_ellipsis}>
                      {this.props.headingname}
                    </span>
                    {subheading && (
                      <span className={s.subheading}>{subheading}</span>
                    )}
                  </Link>
                </HeaderWrapper>
                {sponsoredData}
              </>
            ) : (
              <>
                <HeaderWrapper className={s.heading}>
                  {' '}
                  {this.props.headingname}{' '}
                  {subheading && (
                    <span className={s.subheading}>{subheading}</span>
                  )}{' '}
                </HeaderWrapper>
                {sponsoredData}
              </>
            )}
            {/* {this.props.showWeather && <WithWeather />} */}
            {React.isValidElement(this.props.children) && this.props.children}
          </div>
        </React.Fragment>
      </InViewObserver>
    );
  }
}
Listingheader.propTypes = {
  headingname: PropTypes.string,
  subheading: PropTypes.string,
  isWhiteTheme: PropTypes.bool,
  // showWeather: PropTypes.bool,
  children: PropTypes.element,
  headingLink: PropTypes.string,
  size: PropTypes.string,
  linkData: PropTypes.shape({}),
  newga: PropTypes.string,
  newgaSetCategory: PropTypes.bool,
  loading: PropTypes.bool,
  overrideClass: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  data: PropTypes.shape({
    sponsoredTxt: PropTypes.string,
    sponsoredLink: PropTypes.string,
    sponsoredLogomsid: PropTypes.string,
    sponsoredClass: PropTypes.string,
  }),
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};
Listingheader.defaultProps = {
  headingname: undefined,
  subheading: '',
  isWhiteTheme: false,
  // showWeather: false,
  children: undefined,
  headingLink: '',
  size: '',
  linkData: undefined,
  newga: '',
  newgaSetCategory: false,
  loading: undefined,
  overrideClass: '',
  doNotChangeURL: false,
  data: undefined,
  ga4Type: '',
  ga4Category: '',
};

export default Listingheader;
